/**
 * 华为：华为商店红线规则配置 API 服务（CLAUDE.md §前端 API 服务层 — 按域分目录）。
 *
 * 与后端 Pydantic 模型 src.huawei.dtos.store_redline_config 对齐。
 *   - GET  /api/v1/huawei/store-redline-config          → 全表读
 *   - PUT  /api/v1/huawei/store-redline-config          → 保存（upsert 一批行）
 *   - POST /api/v1/huawei/store-redline-config/seed     → 空表种入 20 行初版
 */

import { request } from "../apiClient";

/** 华为商店红线规则配置行（与后端 StoreRedlineConfigItem 对齐）。 */
export interface StoreRedlineConfigItem {
  field: string;
  parent_id: string;
  child_id: string;
  ope_value: string;
}

/** 华为商店红线规则配置行（含审计列，与后端 StoreRedlineConfigRecord 对齐）。 */
export interface StoreRedlineConfigRecord extends StoreRedlineConfigItem {
  create_user?: string | null;
  modify_user?: string | null;
  created_time?: string | null;
  updated_time?: string | null;
}

export interface SaveStoreRedlineConfigBody {
  rows: StoreRedlineConfigItem[];
}

/** 获取全部华为商店红线规则配置（按 field/parent_id/child_id 排序）。 */
export async function getStoreRedlineConfig(): Promise<StoreRedlineConfigRecord[]> {
  const data = await request<StoreRedlineConfigRecord[] | null>(
    "/api/v1/huawei/store-redline-config",
  );
  return data ?? [];
}

/** 保存（upsert）一批华为商店红线配置行；返回保存后全表（含更新后的审计列）。 */
export async function saveStoreRedlineConfig(
  body: SaveStoreRedlineConfigBody,
): Promise<StoreRedlineConfigRecord[]> {
  const data = await request<StoreRedlineConfigRecord[] | null>(
    "/api/v1/huawei/store-redline-config",
    { method: "PUT", body },
  );
  return data ?? [];
}

/** 空表时种入 20 行初版华为商店红线配置；返回本次种入行数（非空表返回 0）。 */
export async function seedStoreRedlineConfig(): Promise<number> {
  const data = await request<{ seeded: number } | null>(
    "/api/v1/huawei/store-redline-config/seed",
    { method: "POST" },
  );
  return data?.seeded ?? 0;
}
